export const SET_LOADING = "SET_LOADING";
export const SET_CALCULATIONS = "SET_CALCULATIONS";